import * as React from 'react'
import {Util} from 'yougile-util'
import {UIElement} from '../model/ui-element'

interface Props {
  element: UIElement
}
export const ApiElement = (props: Props) => {
  const {element} = props
  const bem = Util.bemFrom('api-element')
  const ref = React.useRef()
  React.useEffect(() => {
    if (ref.current) {
      element.render(ref.current)
    }
    return () => {
      element.onUnmount?.()
    }
  })
  return <div className={bem()} ref={ref} />
}
